import { MainModalProps } from '@/common/components/base/modal/Modal.type';
import ProgressBar from '@/common/components/base/progressBar/ProgressBar';
import Typography from '@/common/components/base/typography/Typography';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import CloseIcon from '@/common/assets/icons/closeIcon.svg?react';
import { token } from 'styled-system/tokens';
import { useEffect } from 'react';

const UploadProgressBarModal = ({
  closeModal,
  open,
  progress,
}: MainModalProps & { progress: number }) => {
  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, []);
  return (
    <Box
      className={css({
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#BCBCBCCC',
        display: open ? 'flex' : 'none',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 'modal',
      })}
    >
      <Box bgColor="white" p={16} w="90%" shadow="cardShadow" borderRadius={8}>
        <Flex
          width="95%"
          mx="auto"
          cursor="pointer"
          mt="20px"
          justifyContent="end"
          onClick={closeModal}
        >
          <CloseIcon stroke={token('colors.black-3')} />
        </Flex>
        <Typography textStyle="b1" color="black-1" mb={12}>
          ارسال و بارگذاری تصاویر
        </Typography>
        <Typography textStyle="b4" color="black-2" mb={24}>
          فرآیند بارگذاری تصاویر در حال انجام است، لطفاً شکیبا باشید.
        </Typography>
        <ProgressBar progress={progress} showPercentage />
      </Box>
    </Box>
  );
};

export default UploadProgressBarModal;
